var popularHotels = vueIfExists({
  el: '#popular-hotels',
  data: {
      pageWidth: Math.max(html.clientWidth, win.innerWidth || 0)
  },
  mounted: function() {
  	var hotelImages = dataLayer[0].popularHotelImages,
  		src,
  		colMdBreakpoint = 1024 + 20;
  	if (hotelImages) {
  		for (var i = 0; i < 8; i++) {
  			if (this.$refs['hotel-'+i]) {
  				src = this.getHotelImageUrl(hotelImages[i]);
  				if (this.pageWidth < colMdBreakpoint) {
  					this.$refs['hotel-'+i].setAttribute('data-bg-img', src);
  				} else {
					 this.$refs['hotel-'+i].setAttribute('style', 'background-image: url("'+src+'")');
				  }
  			}
  		}
  	}
	if (this.pageWidth < colMdBreakpoint) {
  		lazyLoadBackgroundInit({ root: null, rootMargin: '200px' }, 'lazy-hotel');
  	}
  },
  methods: {
  	getHotelImageUrl: function(url) {
			var size = '290x145'; // ratio 1:2

			if (this.pageWidth > 320 && this.pageWidth <= 375) {
				size = '345x173';
			} else if (this.pageWidth > 375 && this.pageWidth < 768) {
				size = '384x192';
			} else if (this.pageWidth >= 768) {
				size = '278x139';
			}
			return this.imageUrl(size, url);
		}
  }
});
